import { environment } from 'src/environments/environment';
export class LoginModel {
  username: string;
  password: string;
  idContry?: string = '1';
  ip?: string;
  platform?: string;

  public static fromResponse(json: any): LoginModel {
    const loginModel: LoginModel = {
      username: json['usuario'],
      password: json['contrasena'],
      idContry: '1',
      ip: json['ip'],
      platform: json['plataforma'],
    };
    return loginModel;
  }

  public static toResponse(loginModel: LoginModel, userIp: string): any {
    const baseRequest = {
      usuario: loginModel.username,
      contrasena: loginModel.password,
      id_pais: '1',
    };

    if (environment.postgres) {
      return {
        ...baseRequest,
        ip: userIp,
        plataforma: 'COVIFACTURA_WEB'
      }
    }

    return baseRequest;
  }
}

export class RecoverPasswordModel {
  username: string;

  public static toResponse(
    recoverPassword: RecoverPasswordModel,
    option: string
  ): any {
    return {
      usuario: recoverPassword.username,
      pagina: 'cambiar-contrasena',
      opcion: option,
    };
  }
}

export class LoginRequestUpdatePassword {
  public user:           string = '';
  public newPassword:           string = '';
  public confirmNewPass?:    string = '';
  public accessCode:        string = '';
}

export class LoginResponseOnUpdatePassword {
   public ok: boolean;
   public data: any;
}
